module.exports = __webpack_public_path__ + "img/marker_four_green1.58012c14.png";